module.exports = __webpack_public_path__ + "media/qxld.4a575b51.mp4";